<ng-container *adaptLoadingUntilFirstEmit="let person of person$">
    <adapt-toolbar-inactive [entity]="person"
                            type="account"> </adapt-toolbar-inactive>

    @if (person) {
        <div adaptToolbarContent>
            @if (canEditSomethingOnPage$ | async) {
                <button adaptButton="tour"
                        data-test="tour-run"
                        (click)="runTour()"></button>
                @if (accountSecurityRoute$ | async; as accountSecurityRoute) {
                    <a *adaptIfAuthorised="ChangePasswordForPerson; entity: person"
                       class="btn btn-secondary"
                       adaptButtonIcon="fal fa-key"
                       adaptTooltip="You can update your login email and change your password here"
                       tooltipPlacement="bottom-left"
                       [routerLink]="accountSecurityRoute.path"
                       [queryParams]="accountSecurityRoute.queryParams"
                       data-test="account-security-button">Account security</a>
                }
                @if (isEditing) {
                    <button adaptButton="view"
                            data-test="view-mode-button"
                            data-tour="view-mode-button"
                            (click)="isEditing = false"></button>
                }
                @if (!isEditing) {
                    <button adaptButton="edit"
                            data-test="edit-mode-button"
                            data-tour="edit-mode-button"
                            (click)="isEditing = true"></button>
                }
            }
            <ng-container *adaptIfAuthorised="ManagePositionAndRoles; entity: person">
                <adapt-user-role-actions [connection]="person.getLatestConnection()"></adapt-user-role-actions>
            </ng-container>
        </div>
    }

    @if (person) {
        <adapt-two-column-page>
            <div left-column>
                <adapt-dashboard-element>
                    <div adapt-dashboard-title-buttons>
                        @if (isEditing) {
                            <button data-tour="edit-profile-name"
                                    adaptButton="editBorderless"
                                    (click)="editName()"></button>
                        }
                    </div>
                    <div adapt-dashboard-title
                         class="profile-header pt-3">
                        @if (!isEditing && !person.imageIdentifier) {
                            <adapt-person-default-image class="me-3"
                                                        imageSize="lg"
                                                        [person]="person"></adapt-person-default-image>
                        }
                        @if (person.imageIdentifier || isEditing) {
                            <adapt-select-image [imageIdentifier]="person.imageIdentifier"
                                                (imageIdentifierChange)="updateImageIdentifier(person, $event)"
                                                [imageWidth]="100"
                                                [defaultImageSrc]="defaultImageSrc"
                                                [disabled]="!isEditing"
                                                [inline]="true"
                                                class="profile-image-container profile-image-container-lg me-3"></adapt-select-image>
                        }
                        <div class="profile-name">
                            <span>{{ person.firstName }} {{ person.lastName }}</span>
                        </div>
                    </div>
                </adapt-dashboard-element>
                <adapt-person-profile-contacts [person]="person"
                                               [editMode]="isEditing"> </adapt-person-profile-contacts>
            </div>
            <div right-column>
                <adapt-person-profile-items [person]="person"
                                            [editMode]="isEditing"> </adapt-person-profile-items>
            </div>
        </adapt-two-column-page>
    }
</ng-container>
